import Generic from "../views/Generic";
import Main from "../components/Main";
import About from "../components/About";
import Skills from "../components/Skills";
import Contact from "../components/Contact";
import MyWork from "../components/MyWork";
import Services from "../components/Services";
export const navItems = [
  // * Home *//
  {
    path: "/home",
    component: Main,
    title: "Home",
    child: [
      { path: "/home/1", title: "1", component: Generic },
      { path: "/home/2", title: "2", component: Generic },
      { path: "/home/3", title: "3", component: Generic },
    ],
  },
  {
    path: "/about",
    title: "About",
    component: About,
    child: [
      { path: "/about/1", title: "1", component: Generic },
      { path: "/about/2", title: "2", component: Generic },
      { path: "/about/3", title: "3", component: Generic },
    ],
  },
  {
    path: "/skills",
    title: "Skills",
    component: Skills,
    child: [
      { path: "/about/1", title: "1", component: Generic },
      { path: "/about/2", title: "2", component: Generic },
      { path: "/about/3", title: "3", component: Generic },
    ],
  },
  {
    path: "/myWork",
    title: "My Work",
    component: MyWork,
    child: [
      { path: "/about/1", title: "1", component: Generic },
      { path: "/about/2", title: "2", component: Generic },
      { path: "/about/3", title: "3", component: Generic },
    ],
  },
  {
    path: "/services",
    title: "Services",
    component: Services,
    child: [
      { path: "/about/1", title: "1", component: Generic },
      { path: "/about/2", title: "2", component: Generic },
      { path: "/about/3", title: "3", component: Generic },
    ],
  },
  {
    path: "/contact",
    title: "Contact",
    component: Contact,
    child: [
      { path: "/about/1", title: "1", component: Generic },
      { path: "/about/2", title: "2", component: Generic },
      { path: "/about/3", title: "3", component: Generic },
    ],
  },
];
